import React, { createContext, useContext, useState, useEffect } from 'react';

const API = "/api";
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(sessionStorage.getItem('ermene_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetch(`${API}/auth/me`, {
        headers: { 'Authorization': `Bearer ${token}` },
      })
        .then(r => {
          if (r.ok) return r.json();
          throw new Error('invalid');
        })
        .then(data => setUser(data))
        .catch(() => {
          setToken(null);
          setUser(null);
          sessionStorage.removeItem('ermene_token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const res = await fetch(`${API}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (res.ok) {
      const data = await res.json();
      setToken(data.access_token);
      setUser(data.user);
      sessionStorage.setItem('ermene_token', data.access_token);
      return { ok: true };
    }
    const err = await res.json().catch(() => ({}));
    return { ok: false, status: res.status, detail: err.detail || 'Errore di login' };
  };

  const logout = () => {
    if (token) {
      fetch(`${API}/auth/logout`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
      }).catch(() => {});
    }
    setToken(null);
    setUser(null);
    sessionStorage.removeItem('ermene_token');
  };

  const authFetch = (url, opts = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      ...opts.headers,
    };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return fetch(url, { ...opts, headers });
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, authFetch }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
